import classnames from 'classnames'
import GatsbyImage from 'gatsby-image'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../../utils/ReactUtils'
import Link from '../../Link'

import styles from './styles'


const decorators = [
  memoized,
]

function MenuLink(props) {
  const { route, selected, routeParams, label, target, enableTab, onTouchEnd, link, onMouseEnter, onMouseLeave } = props

  return (
    <li className={classnames('route', selected && 'selected')} role={'none'}>
      <Link
        route={route}
        routeParams={routeParams}
        link={link}
        tabIndex={enableTab ? 0 : -1}
        aria-label={label}
        className="link"
        target={target}
        onClick={onTouchEnd}
        role={'menuitem'}
      >
        {/* <ImageStatic
          className="cloud"
          src="/images/backgrounds/header-select.svg"
        /> */}
        <span className="label" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>{label}</span>
      </Link>
      <style jsx>{styles}</style>
    </li>
  )
}

MenuLink.propTypes = {
  route: PropTypes.string,
  // eslint-disable-next-line
  routeParams: PropTypes.object,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  link: PropTypes.string,
  target: PropTypes.string,
  enableTab: PropTypes.bool,
  onTouchEnd: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
}

MenuLink.defaultProps = {
  selected: false,
  route: null,
  routeParams: null,
  link: null,
  target: '_self',
  enableTab: true,
}

MenuLink = chainDecorators(decorators, MenuLink)

export default MenuLink
